import { useParams, useSearchParams } from "react-router-dom";
import { useMemo } from "react";

import { useGetInvoiceConfig } from "api/queries/invoice/useGetInvoiceConfig";
import { useGetInvoiceAttachments } from "api/queries/invoice/useGetInvoiceAttachments";
import InvoiceFormOtherAttachmentList from "./InvoiceFormOtherAttachmentList";

function InvoiceFormOtherAttachments() {
  const { id: shipmentId } = useParams();
  const [searchParams] = useSearchParams();
  const currentInvoiceId = searchParams.get("invoice");

  const { data: invoiceConfig }: any = useGetInvoiceConfig({
    shipmentId: shipmentId!,
    currentInvoiceId: currentInvoiceId!,
    options: { refetchOnMount: false },
  });
  const { data: invoiceAttachments }: any = useGetInvoiceAttachments({
    invoiceId: currentInvoiceId!,
    options: { enabled: !!currentInvoiceId, refetchOnMount: false },
  });

  const otherAttachmentBucket = useMemo(
    () => invoiceConfig?.invoice_attachment_bucket?.find((item: any) => item?.bucket_name?.toLowerCase?.() === "other"),
    [invoiceConfig],
  );
  const existingOtherBucketAttachments = useMemo(
    () =>
      invoiceAttachments?.bucket_attachments
        ?.filter((item: any) => item?.attachment_bucket?.bucket_type === "other")
        .map((item: any) => ({
          ...item.file,
          stop: item.stop || null,
        })),
    [invoiceAttachments],
  );

  return (
    <div className="mt-2">
      {otherAttachmentBucket ? (
        <InvoiceFormOtherAttachmentList
          key={currentInvoiceId}
          existingFiles={existingOtherBucketAttachments}
          attachmentBucketId={otherAttachmentBucket.id}
          stopAssociationEnabled={!!invoiceConfig?.stop_association_enabled}
          shipmentStops={invoiceConfig?.shipment_stops || []}
        />
      ) : (
        <InvoiceFormOtherAttachmentList key={currentInvoiceId} existingFiles={invoiceAttachments?.other_attachments} />
      )}
    </div>
  );
}

export default InvoiceFormOtherAttachments;
